import React from "react"

import ItemModelV2 from "../../../../../../model2/item2/item-model"
import TasksView_Column from "../../../../../../model2/column/column"
import FieldProto from "../../../../../proto/field-proto"

type Props = {
    style?          : any

    listItem        : ItemModelV2
    column          : TasksView_Column
    field           : FieldProto

    isEditable      : boolean
    showPopover     : boolean

    onMouseEnter    : callback
    onMouseLeave    : callback
    onValueChange   : callback
    hidePopover     : func
    onClick         : func
    onDeleteClick   : func
}

// const debug = "FieldProgress_TableCellCalculated_Hovered"
const debug = false

export default class FieldProgress_TableCellCalculated_Hovered extends React.Component<Props>{

    onValueChange = async (value: any, hidePopover: boolean = true) => {
        this.props.onValueChange(value, hidePopover)
    }

    hidePopover = () => {
        this.props.hidePopover()
    }

    render() {
        const value = _.get(this.props.listItem.item, this.props.field.fieldId, 0)
        const excess = value > 100;
        const currentValue = excess ? Math.floor(100 * (100 / value)) : value;
        const progressClasses = Classes("ui5-progress", "in-ui5-field", {
            'excess-v2':    excess,
        })

        const contentClasses   = Classes("ui5-txt-less-important-small w-100-percent flex-row-left-center txt-truncate")

        const displayProgressBar = !!this.props.style.width && this.props.style.width > 70

        let content
        if (!_.isNil(value)) {
            if (!displayProgressBar) {
                content = (
                    <div className={contentClasses}>
                        <div className={progressClasses}>
                            {!_.isNil(currentValue) &&
                                <div className="ui5-txt-less-important-small percentage txt-truncate">
                                    {"{0}%".f(currentValue)}
                                </div>
                            }
                        </div>
                    </div>
                )
            } else {
                content = (
                    <div className={contentClasses}>
                        <div className={progressClasses}>
                            <div className="progress-bg">
                                {!!currentValue &&
                                    <div className  = "progress-line"
                                         style      = {{width: '{0}%'.f(currentValue)}}
                                    />}
                            </div>
                            {!_.isNil(currentValue) &&
                                <div className="m-l-10 ui5-txt-less-important-small">
                                    {"{0}%".f(currentValue)}
                                </div>
                            }
                        </div>
                    </div>
                )
            }
        } else {

        }

        const field     = this.props.field
        const classes   = Classes("cell-flex", "is-hovered")

        return (
            <div className      = {classes}
                 style          = {this.props.style}
                 onMouseEnter   = {this.props.onMouseEnter}
                 onMouseLeave   = {this.props.onMouseLeave}
            >
                <div className  = "ui5-field-editable size-small is-hovered w-100-percent h-100-percent"
                     onClick    = {this.props.onClick}
                >

                    {content}
                    {!value && (
                        <div className="ui5-txt-less-important-small w-100-percent flex-row-left-center txt-truncate">
                            {this.props.field.label}
                        </div>
                    )}

                    <div className="buttons flex-no-shrink">
                        {!!value &&
                            <div className  = "btn-reset"
                                 onClick    = {this.props.onDeleteClick}
                            />}
                        <div className="btn-arrow"/>
                    </div>

                </div>

                {this.props.showPopover &&
                    <field.components.PopoverMenu
                        {...this.props}
                        parent={this}
                    />
                }
            </div>
        )
    }
}